<script lang="ts">
  /**
   * The single place `{@html}` is allowed in the app.
   *
   * @nrk/core-icons v19 exports icons as SVG *strings*, so rendering one requires
   * {@html}. The content is a compile-time constant from a trusted package — never
   * user input — so this is safe, but it must stay contained to this file rather
   * than spreading eslint-disable comments across every component.
   *
   * Icons are 1.5em and use currentColor, so they size with font-size and inherit
   * colour from the parent. Pass `size` as any CSS length.
   *
   *   <Icon svg={trashcanIcon} />                       decorative
   *   <Icon svg={trashcanIcon} label="Slett deltaker" /> meaningful
   */
  interface Props {
    /** An icon string from @nrk/core-icons, e.g. `trashcanIcon` */
    svg: string;
    /** Accessible name. Omit for decorative icons sitting next to a text label. */
    label?: string;
    /** Any CSS length. Defaults to inheriting the parent font-size. */
    size?: string;
  }

  let { svg, label, size }: Props = $props();
</script>

<span
  class="icon"
  style:font-size={size}
  role={label ? 'img' : undefined}
  aria-label={label}
  aria-hidden={label ? undefined : 'true'}
>
  <!-- eslint-disable-next-line svelte/no-at-html-tags -- trusted constant from @nrk/core-icons; see comment above -->
  {@html svg}
</span>

<style>
  .icon {
    display: inline-flex;
    flex-shrink: 0;
    line-height: 0;
  }
</style>
